<template lang="pug">
  .home
    main-map
    tag-list
</template>

<script>
import MainMap from '@/components/MainMap'
import TagList from '@/components/TagList'

export default {
  name: 'home',
  components: {
    MainMap,
    TagList
  },
  created () {
    this.$store.dispatch('tag/getTagList', null, { root: true })
    this.$store.dispatch('bus/getBusList', null, { root: true })
    this.$store.dispatch('socket/connect', null, { root: true })
  }
}
</script>

<style scoped>
.home {
  display: flex;
  height: 100vh;
  box-sizing: border-box;
}
</style>
